/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { jsx } from '@compiled/react';

/**
 * Sparkle glyph component with animated 4-pointed star cutout
 */
export const Sparkle = () => (
	<svg
		width="598"
		height="599"
		viewBox="0 0 598 599"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<defs>
			<mask id="sparkle-mask">
				<rect width="598" height="599" fill="white" />
				<path
					data-sparkle-path
					d="M597.838 299.081C432.742 299.081 298.919 165.185 298.919 0C298.919 165.185 165.096 299.081 0 299.081C165.096 299.081 298.919 432.976 298.919 598.161C298.919 432.976 432.742 299.081 597.838 299.081Z"
					fill="black"
				/>
			</mask>
		</defs>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M298.919 0C463.989 0 597.812 133.896 597.838 299.081C597.838 464.266 464.015 598.161 298.919 598.161V598.135C133.823 598.135 0 464.24 0 299.081C0 133.896 133.823 0 298.919 0Z"
			fill="currentColor"
			mask="url(#sparkle-mask)"
		/>
	</svg>
);
